var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#fff","d":"M0 4.2h3V14H0zM5.6 0h2.8v14H5.6zm5.6 8H14v6h-2.8z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }